import React, { useState } from "react";
import { Grid, Button, Paper, CircularProgress, Typography, FormGroup } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "../Shared/FormControls/DatePicker";
import { IReportRequest } from "../../interfaces/Report/IReportRequest";
import Api from "../../Api";
import { ExpandableContainer } from "../Shared/ExpandableContainer";
import { BreadcrumbBar } from "../Breadcrumb";

interface ReportFormProps {
    title: string,
    reportType: string
}

const ReportForm = ({ title, reportType }: ReportFormProps) => {
    const [fromDate, setFromDate] = useState<string | null>(null);
    const [toDate, setToDate] = useState<string | null>(null);

    const [createdFromDate, setCreatedFromDate] = useState<string | null>(null);
    const [createdToDate, setCreatedToDate] = useState<string | null>(null);



    const [exportingReport, setExportingReport] = useState(false);

    const navigate = useNavigate();


    const handleSubmit = () => {
        setExportingReport(true);

        let reportRequest: IReportRequest = {
            reportType,
            from: fromDate,
            to: toDate,
            createdFrom: createdFromDate,
            createdTo: createdToDate
        }


        Api.Reports.export(reportRequest)
            .then((response: any) => response.blob())
            .then((blob) => {

                const filename = `${reportType} - ${new Date().toUTCString()}.csv`;

                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );

                const link: HTMLAnchorElement = document.createElement('a');

                link.href = url;
                link.setAttribute(
                    'download',
                    filename,
                );
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);

                setExportingReport(false);
            }).catch((r) => {
                console.log("error while exporting", r);
                setExportingReport(false);
            });


    }

    const sentenceCase = (val: string) => {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    return (
        <ExpandableContainer>
            <BreadcrumbBar
                current={title}
                previous={[{
                    name: "Report",
                    href: "/report"
                }]}
            />
            <Paper sx={{ p: 4, mx: "auto", mt: 4 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                            <DatePicker
                                label={sentenceCase(reportType) + " From Date"}
                                value={fromDate}
                                onChange={setFromDate}
                            />
                            <span> </span>
                            <DatePicker
                                label={sentenceCase(reportType) + " To Date"}
                                value={toDate}
                                onChange={setToDate}
                            />
                    </Grid>
                    <Grid item>
                        <DatePicker
                            label="Created From Date"
                            value={createdFromDate}
                            onChange={setCreatedFromDate}
                        />
                        <span> </span>
                        <DatePicker
                            label="Created To Date"
                            value={createdToDate}
                            onChange={setCreatedToDate}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            disabled={exportingReport}
                        >
                            {exportingReport ? <CircularProgress size={"1.5rem" } /> : "Run Report"}
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </ExpandableContainer>
    );
};

export const StorageReportForm = () => <ReportForm title="Storage Requests Report" reportType="storage" />;
export const DispatchReportForm = () => <ReportForm title="Dispatch Requests Report" reportType="dispatch" />;
